var _style, _path, _g, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggNoodles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29384F;}\n\t.st1{fill:#F59B2D;}\n\t.st2{fill:#EF7921;}\n\t.st3{fill:#FBBB4B;}\n\t.st4{fill:none;stroke:#FFEECC;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 107.75,
    cy: 74.46,
    rx: 35.19,
    ry: 23.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.75,88.48c-16.99,0-31.16-8.08-34.46-18.82c-0.48,1.55-0.73,3.16-0.73,4.8 c0,13.05,15.76,23.62,35.19,23.62c19.44,0,35.19-10.58,35.19-23.62c0-1.64-0.25-3.25-0.73-4.8 C138.9,80.4,124.73,88.48,107.75,88.48z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 118.18,
    cy: 63.46,
    rx: 11.16,
    ry: 4.04
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M155.97,118.33c-5.85,0.8-14.88,1.66-25.89,1.08c-2.46-0.13-9.84-0.58-31.82-4.31 c-7.95-1.35-16.2-4.13-24.47-3.49c-4.1,0.32-8.06,1.58-11.2,4.31c-3.19,2.77-9.76,11.28-2.85,13.82c3.08,1.13,7.55,0.55,10.86,0.56 c4.73,0.01,9.45-0.05,14.18-0.09c12.48-0.11,15.77-0.1,19.42,0c9.55,0.26,18.94,2.41,28.49,1.01c4.57-0.67,10.72-4.82,15.42-2.95 c7.17,2.85-1.76,15-5.63,17.05c-3.35,1.77-6.14,1.1-21.03-2.16c-16.77-3.67-19.37-4.17-23.19-3.78 c-4.66,0.48-11.26,2.31-18.88,8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M161.91,97.7c-2.97,3.91-13.52,13.17-18.88,15.91c-15.72,8.06-30.35,8.31-37.75,8.36 c-19.65,0.12-23.19-1.87-24.27-2.97c-4.46-4.52-2.01-9.37-6.47-13.21c-6.34-5.46-21.54-4.52-26.97,4.85 c-3.39,5.85-2.92,14.9,1.35,17.53c4.95,3.05,10.54-5.28,21.3-4.58c8.47,0.55,8.77,5.95,20.22,10.79 c1.92,0.81,22.38,9.15,36.13,0.27c5.53-3.57,5.12-6.79,11.33-9.44c6.26-2.66,16.65-3.64,20.49,2.16c2.52,3.8,2.07,10.27-1.08,12.4 c-3.97,2.69-9.01-3.73-15.64-1.89c-6.52,1.81-6.81,9.46-12.13,14.29c-4.8,4.36-14.38,7.05-35.33,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.24,110.11c2.71-4.95,6.87-10.7,12.4-11.06c3.9-0.25,6.07,2.33,11.87,5.39c0,0,9.55,5.04,20.22,5.93 c4.11,0.34,14.08,0.4,26.43-7.82c9.71-5.02,15.19-6.73,16.45-5.12c1.29,1.64-6.52,7.35-5.12,10.25c2.1,4.38,21.52-4.34,26.43,2.16 c2.2,2.91,1.39,8.73-1.62,12.13c-7.99,9.05-25.85-5.48-42.07,3.24c-12.12,6.52-9.99,18.86-20.49,21.03 c-9.62,1.99-14.59-7.68-29.12-8.36c-8.27-0.38-15.22,2.35-19.96,4.85"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggNoodles);
export default __webpack_public_path__ + "static/media/Egg_noodles.eb9df2c6289eea9d63268242eaff26d9.svg";
export { ForwardRef as ReactComponent };